import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=95177eaa&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=95177eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95177eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95177eaa')) {
      api.createRecord('95177eaa', component.options)
    } else {
      api.reload('95177eaa', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=95177eaa&scoped=true&", function () {
      api.rerender('95177eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iV9oQSJm7xxI/JS/comp/PopupDialog.vue"
export default component.exports